export default __webpack_public_path__ + "static/media/mozen.0f6ef6a9.webp";